module.exports = __webpack_public_path__ + "static/img/phone.906dd1ab.png";